import { NumberField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { InlineAlert } from 'components/core/inline-alert';
const styledNumberFieldCss = "s15k3dr6";
const StyledNumberField = forwardRef((props, ref) => <NumberField ref={ref} {...props} className={classNames(styledNumberFieldCss, props.className)} />);
export const MaxInviteeInput = ({
  hasSmsNotification,
  useUpdatedLabel,
  errorOnInputOnly = false,
  labelledBy = null
}) => {
  const [, {
    value
  }] = useFormField({
    name: 'inviteesLimit'
  });
  const label = useUpdatedLabel ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.max_invitees_field_label') : I18n.t('publisher.event_types.general.max_invitees');
  return <>
      <StyledNumberField required label={labelledBy ? null : label} aria-labelledby={labelledBy} errorOnInputOnly={errorOnInputOnly} proTip={I18n.t('publisher.event_types.general.max_invitees_tooltip')} name="inviteesLimit" />
      {value > 100 && hasSmsNotification && <InlineAlert>
            {I18n.t('publisher.workflows.notifications.limits.event_type_edit.general')}
          </InlineAlert>}
    </>;
};

require("./max_invitees_input.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./max_invitees_input.js");